import { message } from "antd";
import React from "react";
import TopbarCartWrapper from "./SingleCartModal.style";
import { useTranslation } from "../../utils/locales/useTranslation";
import { sourceKey } from "../../utils/locales/config";

export default function ({
  productPricingList,
  quantity,
  productImageList,
  productID,
  cancelQuantity,
  productName,
}) {
  const { t } = useTranslation();
  const data =
    window.location.href.includes("checkoutSummary") ||
    window.location.href.includes("checkout");

  return (
    <TopbarCartWrapper className="isoCartItems">
      <div className="isoItemImage">
        <img alt="#" src={productImageList[0].url} />
      </div>
      <div className="isoCartDetails">
        <h3>
          {productName}
          {/* <a href="#!">{productName}</a> */}
        </h3>
        <p className="isoItemPriceQuantity">
          <span>{t("AGP", sourceKey.user)}&nbsp;</span>
          <span>{productPricingList[0].memberPrice.toFixed(2)}</span>
          <span className="itemMultiplier">X</span>
          <span className="isoItemQuantity">{quantity}</span>
        </p>
      </div>
      {!data && (
        <a className="isoItemRemove" onClick={() => cancelQuantity(productID)}>
          <i className="ion-android-close" />
        </a>
      )}
    </TopbarCartWrapper>
  );
}
